import React from 'react';

interface SendEvent {
  type: string;
  payload?: any;
}
export type SendContextProps = {
  send: (event: SendEvent) => any;
  context: any;
  children?: React.ReactNode;
};
export const SendContext = React.createContext<SendContextProps>({
  send: () => {},
  context: {},
  children: undefined,
});

export const SendContextProvider: React.FC<SendContextProps> = ({
  send,
  context,
  ...props
}) => {
  return (
    <SendContext.Provider value={{ send: send, context: context }}>
      {props.children}
    </SendContext.Provider>
  );
};
